import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import LoadConfigPopup from '../ConfigPopups/LoadConfigPopup';
import SaveConfigPopup from '../ConfigPopups/SaveConfigPopup';
import RequestBudgetPopup from '../RequestBudgetPopup/RequestBudgetPopup';
import Login from '../User/Login';
import Logout from '../User/Logout';
import LegalNote from '../LegalNote/LegalNote';
import UnitSelector from '../UnitSelector/UnitSelector';
import RulesPopup from '../RulesPopup/RulesPopup';
import { PopupState } from '../../model/constants';

const PopupManager = () => {
    const { popupState } = useSelector(state => state.configurator);

    useEffect(() => {
        // console.log(`popupState: ${popupState}`);
    }, [popupState]);

    switch (popupState) {
        case PopupState.Login:
            return <Login />;
        case PopupState.Logout:
            return <Logout />;
        case PopupState.UnitSelector:
            return <UnitSelector />;
        case PopupState.Rules:
            return <RulesPopup />;
        case PopupState.LoadConfiguration:
            return <LoadConfigPopup />;
        case PopupState.SaveConfiguration:
            return <SaveConfigPopup />;
        case PopupState.RequestBudget:
            return <RequestBudgetPopup />;
        case PopupState.LegalNote:
            return <LegalNote />;
        default:
            return null;
    }
};
export default PopupManager;
